<div class="track-my-location-container">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12 contact-info">
        <a href="" target="_blank">
          <img width="200" src="/assets/images/temp/MI_black_logo.png">
        </a>
      </div>
    </div>
    <div class=" col-nopad col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>

    <div class="gap-12 md:col-12 lg:col-12">
      <div [innerHTML]="privacyPolicyData"></div>
    </div>
  </div>
</div>